import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import routeRegister from '../../../helpers/routeRegister';
import { generateRoutes } from '../../../helpers/hotelModuleHelper';
import { selectors } from '../reducers/hotelListino';

const routes = generateRoutes('listini', selectors, {
    itemLabelKey: 'nomi.it'
});

const list = _.values(routes.list).map(route => ({
    ...route,
    hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'listini-hotel' */ `modules/hotelListino/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('hotelListino', routes.patterns, {
    it: 'Listini Hotel'
});
routeRegister.addLinks('hotelListino', links);

export default list;
